import { Button, Filters, Modal, OptionList } from "@shopify/polaris";
import React, { useCallback, useMemo, useState } from "react";
import { useAppQuery } from "../../../hooks/index.js";

interface IPost {
  id: string,
  title: string
  blogHandle: string
  postHandle: string
}

interface IPosts {
  posts: IPost[];
}

const SelectBlogModal = ({ input }) => {
  const [active, setActive] = useState(false);
  const [queryValue, setQueryValue] = useState("");

  const handleQueryValueRemove = useCallback(() => {
    setQueryValue("");
  }, []);

  const handleClearAll = useCallback(() => {
    handleQueryValueRemove();
  }, [handleQueryValueRemove]);

  const handleChange = useCallback(() => setActive(!active), [active]);

  const handleClose = useCallback(() => {
    setActive(!active);
  }, [active]);

  const handleSelect = useCallback((value) => {
    input.onChange(value.filter(item => item !== input.value[0]));
  }, [input]);

  const activator = <Button plain onClick={handleChange}>Select Specific Shopify Blog</Button>;

  const { isLoading, data } = useAppQuery<IPosts, Error>({
    url: "/api/online-store/blogs",
    reactQueryOptions: {},
    fetchInit: {}
  });

  const options = useMemo(() => {
    if (data?.posts) {
      return data.posts.map(post => {
        return {
          value: `${post.blogHandle}/${post.postHandle}`,
          label: post.title
        };
      });
    }

    return [];
  }, [data]);

  const handleClear = useCallback(() => {
    input.onChange([]);
  }, [input]);


  return (
    <Modal
      activator={activator}
      open={active}
      onClose={handleClose}
      loading={isLoading}
      title="Select blog"
      primaryAction={{
        content: "Done",
        onAction: handleClose
      }}
      secondaryActions={[
        {
          content: "Clear",
          onAction: handleClear
        }
      ]}
    >
      <Modal.Section>
        <Filters
          queryPlaceholder={"Search"}
          queryValue={queryValue}
          filters={[]}
          onQueryChange={setQueryValue}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleClearAll}
        />
      </Modal.Section>
      <Modal.Section>
        <OptionList
          title=""
          onChange={handleSelect}
          options={options.filter(item => item.label.includes(queryValue))}
          selected={input.value}
          allowMultiple
        />
      </Modal.Section>
    </Modal>
  );
};

export default SelectBlogModal;